import React from "react"
import { Card } from "antd"
import { Link } from "react-router-dom"

import getDownloadTitleImageUrl from "./DownloadImageUrls"

const NewsCard = ({ oneNews, cardClassName, titleContainerClassName, imageClassName, imageContainerClassName }) => {
	return (

		<Link to={ `/oneNews/${ oneNews.id }` }>
			<Card
				className={ cardClassName }
				styles={ { body: { padding: "0" } } }
				variant="borderless"
			>
				<div>
					<div className={ imageContainerClassName }>
						<img
							alt="news_image"
							className={
								imageClassName
							}
							src={ getDownloadTitleImageUrl(oneNews.titleImageId, oneNews.id) }
						/>
					</div>
					<div className={ titleContainerClassName }>
						<h4>
							{ oneNews.title }
						</h4>
					</div>
				</div>
			</Card>
		</Link>

	)
}

export default NewsCard